export default __webpack_public_path__ + "static/media/nostalgia8.22e4b367.jpg";